const PLAN_REQUIRED = {type: "PLAN_REQUIRED", redirectTo: '/plans', redirectToState: 'blocked.plans'};

export default class PlansStateService {
    [x: string]: any;
 	 static $inject = ['$q','AuthService','$localStorage'];
    constructor($q, AuthService, $localStorage) {
        this.$q = $q;
        this.AuthService = AuthService;
        this.$localStorage = $localStorage
    }

    checkPlan() {
        return this.$q((resolve, reject) => this.planRequired() ? reject(PLAN_REQUIRED) : resolve())
    }

    planRequired() {
        return this.AuthService.currentUser().shouldForcePayment;
    }

}
